module.exports = __webpack_public_path__ + "img/0Q3B8639-42_H.7d9bfdb6.webp";